import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    delay: { type: Number, default: 300 },
    minLength: { type: Number, default: 3 }
  }

  disconnect() {
    clearTimeout(this.timer)
  }

  search(event) {
    clearTimeout(this.timer)
    const value = event.target.value.trim()
    if (value.length > 0 && value.length < this.minLengthValue) return

    this.timer = setTimeout(() => {
      this.element.requestSubmit()
    }, this.delayValue)
  }

  pushUrl(event) {
    if (event.detail?.success === false) return
    const url = event.detail?.fetchResponse?.response?.url
    if (url) history.replaceState({}, "", url)
  }
}
